import type { EntityVault } from '@/types/vault';

const hasNationality = (vault: EntityVault | undefined) => {
  const vaultDIs = Object.keys(vault || {});
  return vaultDIs.some(di => di === 'id.nationality');
};

export default hasNationality;
